import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { TopHeading } from "../../components/heading/TopHeading";
import NetworkImage from "../../components/image/NetworkImage";
import { useTranslationEx } from "../../hooks/useTranslationEx";
import axiosInstance from "../../services/axiosInstance";
import Utils from "../../utils/utils";
import { icAsset } from "../../components/image/image-src";

interface Category {
  lable: string;
  value: string | null;
}

const EventList: React.FC = () => {
  const [selectedCategory, setSelectedCategory] = useState<string | null>(null);
  const { t2: t } = useTranslationEx();
  const [categories, setCategories] = useState<Category[]>([
    { lable: t("All"), value: null },
    { lable: t("tab ongoing"), value: "ONGOING" },
    { lable: t("up comming"), value: "UPCOMMING" },
    { lable: t("ended"), value: "ENDED" },
  ]);
  const [cards, setCards] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        setLoading(true);
        const response = await axiosInstance.get("/event/");
        const { result } = response.data;

        // Transform cards to match the expected format
        const fetchedCards = result.cards.map((card: any) => ({
          id: card.id,
          image: `${card.thumbnail}`,
          title: card.title,
          startTime: card.startDate || new Date(),
          category: card.category,
          content: card.content,
        }));

        setCards(fetchedCards);
      } catch (err) {
      } finally {
        setLoading(false);
      }
    };

    fetchEvents();
  }, []);

  const handleCategoryClick = (categoryId: string | null) => {
    setSelectedCategory(categoryId);
  };

  const renderCategory = () => {
    return (
      <div className="mb-[2.875rem] mt-[5.0625rem]">
        <Swiper slidesPerView={"auto"} spaceBetween={6}>
          {categories.map((category) => (
            <SwiperSlide className="max-w-fit" key={category.value}>
              <button
                key={category.value}
                className={`px-[1.0625rem] py-2 text-[0.875rem] font-normal leading-[1.25rem] ${
                  selectedCategory === category.value
                    ? "bg-black text-white"
                    : "border border-[#EAEEF3] bg-white text-[#232323]"
                } rounded-[3.125rem]`}
                onClick={() => handleCategoryClick(category.value)}
              >
                {category.lable}
              </button>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    );
  };

  const renderCard = (card: any) => {
    const handleCardClick = () => {
      navigate(`/events/${card.id}`);
    };
    return (
      <div
        key={t(card.title)}
        onClick={handleCardClick}
        className="relative aspect-[23/10] cursor-pointer overflow-hidden rounded-[1.25rem] sm:aspect-auto sm:h-[10rem]" //sm:h-[12.5rem] sm:w-[36.75rem]
      >
        <NetworkImage
          className="h-full w-full object-cover"
          src={card.image}
          alt={card.title}
        />
        <div
          className="absolute top-0 h-full w-full p-6 text-white"
          style={{
            background:
              "linear-gradient(180deg, rgba(0, 0, 0, 0.6) 0%, rgba(0, 0, 0, 0) 100.04%)",
          }}
        ></div>
        <div className="absolute left-6 top-5">
          <h3 className="font-semibold text-white sm:text-base sm:leading-[1.5]">
            {t(card.title)}
          </h3>
          <p className="text-base leading-[1.3619rem] text-white">
            {Utils.formatDate(new Date(card.startTime))}
          </p>
        </div>
      </div>
    );
  };

  const renderCards = () => {
    return cards
      .filter(
        (card) =>
          selectedCategory === null || card.category === selectedCategory,
      )
      .map((card) => {
        return renderCard(card);
      });
  };

  if (loading) return null;
  if (error) return <p>{error}</p>;

  return (
    <div className="sm:mb-[9.5rem]">
      <div className="relative">
        <TopHeading varis={["WHITE_CART", "STICKY"]} />
        <img
          src={icAsset("../../assets/images/banner-event.png")}
          className="h-[12.75rem] object-cover"
          alt=""
        />
        <div className="absolute left-1/2 top-1/2 translate-x-[-50%] translate-y-[-50%] text-center">
          <h1 className="mb-2 text-[2rem] font-semibold leading-[2.8rem] text-white">
            {t("Events")}
          </h1>
          {/* <p className="text-[1.125rem] font-normal leading-[1.75rem] text-white">
            {t(
              "Instant global connectivity with our easy-to-activate E-sim service",
            )}
          </p> */}
        </div>
      </div>
      <div className="ui-container mx-auto sm:max-w-[75rem]">
        {/* {renderCategory()} */}
        <div className="mb-[2.875rem] mt-[2.875rem] grid gap-3 sm:grid-cols-3 sm:gap-6">
          {renderCards()}
        </div>
      </div>
    </div>
  );
};

export default EventList;
